import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { submit } from 'redux-form'

import { LocationEditModalWrapper } from 'Components/City/Page/Locations/Modals/LocationEditModalWrapper'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import { LocationEditForm } from 'Containers/Form/City/Locations/LocationEdit'
import {
  updateLocationById,
  getLocationById,
  clearLocationById,
} from 'Reducers/Location/actions'
import SubmitButton from 'Components/Form/SubmitButton'

const LocationEditModal = props => {
  const dispatch = useDispatch()
  const submitLocationEditForm = () => dispatch(submit('locationEditForm'))
  const location = useSelector(state => state.locations.locationById)
  const handleFormSubmit = values => {
    const { handleSuccess, locationId } = props
    const payload = {
      name: values.name.replace('(Archived)', ''),
      label: values.label,
      is_event: values.isEvent,
      type_id: values.typeId,
      moments_morning: values.moments.morning,
      moments_lunch: values.moments.lunch,
      moments_afternoon: values.moments.afternoon,
      is_sheltered: values.isSheltered,
      status: values.status ? values.status : null,
    }
    const callbacks = {
      onSuccess: handleSuccess,
    }
    dispatch(updateLocationById(callbacks, locationId, payload))
    updateLocationById(callbacks, locationId, payload)
  }

  useEffect(() => {
    const { locationId } = props
    dispatch(getLocationById(locationId))
  }, [])

  useEffect(() => {
    const { locationId } = props
    dispatch(clearLocationById(locationId))
  }, [])
  const { handleCancel, locationTypeOptions } = props
  if (!location.id) return null

  return (
    <LocationEditModalWrapper>
      <Modal show={true}>
        <ModalHeader closeButton onHide={handleCancel}>
          <ModalTitle>Edit Location</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <LocationEditForm
            locationTypeOptions={locationTypeOptions}
            location={location}
            onSubmit={handleFormSubmit}
          />
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            variant="outlined"
            value="Cancel"
            onClick={handleCancel}
          />
          <SubmitButton value="Update" onClick={submitLocationEditForm} />
        </ModalFooter>
      </Modal>
    </LocationEditModalWrapper>
  )
}

export default LocationEditModal



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/Modals/LocationEdit/index.js